<div class="print-vdp container">
  <div class="print-vdp__header mb-4">
    <ng-content *ngTemplateOutlet="title"></ng-content>
  </div>

  <div class="row mb-4">
    <div class="col-sm-8">
      @if (images && images.length > 0) {
        <img [src]="images[0].url" alt="{{autovisionPrintVdpTranslations.mainImage}}" class="w-100" />
      } @else {
        <div class="w-100">
          <app-vehicle-icon></app-vehicle-icon>
        </div>
      }
    </div>
    <div class="col-sm-4 px-0">
      <app-auto-vision-auction-detail></app-auto-vision-auction-detail>
    </div>
  </div>
  <div class="container">
    <div class="row mb-4">
      <app-auto-vision-vehicle-details></app-auto-vision-vehicle-details>
    </div>
  </div>
  <div class="container">
    <div class="row mt-2 pt-4 mb-2">
      <div class="col">
        <div class="border-top"></div>
      </div>
    </div>
    <div class="row">
      <div class="col mb-4">
        <app-auto-vision-equipment-accessories variant="static"></app-auto-vision-equipment-accessories>
      </div>
    </div>
    <div class="row my-2 my-4">
      <div class="col">
        <div class="border-top"></div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-8">
        <app-auto-vision-condition-disclosures></app-auto-vision-condition-disclosures>
      </div>
      <div class="col-md-4">
        <app-auto-vision-seller-location class="mt-4"></app-auto-vision-seller-location>
      </div>
    </div>
    <div class="print-vdp__images">
      <h3 class="text-uppercase fw-bold h5" data-test-id="app-auto-vision-print-vdp-e-header">{{autovisionPrintVdpTranslations.photos}}</h3>
      <div class="row">
        @for (image of images; track image) {
          <div class="image-wrapper">
            <img [src]="image.url" alt="" class="me-4 my-4" />
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #title>
  <div class="print-vdp__header--wrapper wrapper d-flex align-items-end">
    <h1 id="" class="m-0 p-0">{{ header.title }}</h1>
    <p class="p-0 m-0 ms-2">
      {{ header.description }}
      {{ header.vin }}
    </p>
  </div>
</ng-template>


<ng-template #NA let-id="id">
  <dd class="value mb-0" [id]="id">N/A</dd>
</ng-template>
